﻿import mixin from './mixin';
import { userStore } from './store/userStore.js';
import { initMenu } from '../project/hamburger';
import { getCookie} from '../functions';
import bulmaCollapsible from '@creativebulma/bulma-collapsible';

const userStateApp = {
    mixins: [mixin],
    data() {
        return {
            userApi: '',
            redirect: '/'
        }
    },
    computed: {
        user() {
            return userStore.user;
        },
        loggedIn() {
            return userStore.loggedIn;
        }
    },
    computed: {
        user() {
            return userStore.user;
        },
        loggedIn() {
            return userStore.loggedIn;
        }
    },
    methods: {
        async init() {
            initMenu();
            window.addEventListener('memberChanged', async (event) => {
                userStore.user = event.detail.user;
                if (!Object.keys(event.detail.user).length) {
                    userStore.loggedIn = false;
                } else {
                    userStore.loggedIn = true;
                }
            });
            if (sessionStorage.getItem('member') === null || !getCookie('memberCheck')) {
                const memberResponse = await this.fetchApiData(this.userApi, '', 'get');
                if (!memberResponse || memberResponse.data.id === null || memberResponse.status !== 200) {
                    userStore.loggedIn = false;
                } else {
                    userStore.updateUser(memberResponse.data);
                    userStore.loggedIn = true;
                }
            } else {
                userStore.user = JSON.parse(sessionStorage.getItem('member'));
                userStore.loggedIn = true;
            }

            this.$nextTick(() => {
                const bulmaCollapsibleInstancesVue = bulmaCollapsible.attach('.is-collapsible--vue');

                bulmaCollapsibleInstancesVue.forEach(bulmaCollapsibleInstance => {
                    bulmaCollapsibleInstance.on('after:expand', function () {
                        bulmaCollapsibleInstance._originalHeight = bulmaCollapsibleInstance.element.scrollHeight + 'px';
                    });

                    if (bulmaCollapsibleInstance.element.id === 'mainSearch') {
                        const $form = bulmaCollapsibleInstance.element;
                        const $input = $form.querySelector('input');
                        const $button = $form.querySelector('button');
                        let buttonClicked = false;
                        $button.addEventListener('click', (event) => {
                            buttonClicked = true;
                        });
                        $input.addEventListener('blur', () => {
                            setTimeout(() => {
                                if (!buttonClicked) {
                                    bulmaCollapsibleInstance.collapse();
                                }
                            }, 300);
                        });
                        bulmaCollapsibleInstance.on('after:expand', () => {
                            $input.focus();
                        });
                        $form.addEventListener('submit', function (e) {
                            e.preventDefault();
                            if ($input.value.trim() !== '') {
                                $form.submit();
                            } else {
                                $input.focus();
                            }
                        });
                    }
                });
            });
        }
    },
    mounted() {
        if (this.$el.parentNode.dataset.userapi) this.userApi = this.$el.parentNode.dataset.userapi;
        if (this.$el.parentNode.dataset.redirect) this.redirect = this.$el.parentNode.dataset.redirect;
        this.init();
    }
}

export default userStateApp;